export default __webpack_public_path__ + "static/media/triggerLogsIcon.30445920.svg";